<template>
  <div class="page-footer" >
    <div class="en-content">
      <div class="menu-contact">
        <div class="enhe-phone">
          <p class="enhe">
            <img src="https://icc-oss.oss-cn-hangzhou.aliyuncs.com/Enhe-official-website/footer-logo.png" alt="">
            浙江恩赫集团
          </p>
          <p class="phone">
            <img src="https://icc-oss.oss-cn-hangzhou.aliyuncs.com/Enhe-official-website/footer-phone.png" alt="">
            4008619660</p>
        </div>
        <ul class="menu-li">
          <li @click="toPage(item.path)" class="menu-item" v-for="item in menuList" :key="item.path">{{item.name}}</li>
        </ul>
        <div class="address">
          <p class="title">联系方式</p>
          <p @click="pageTo" style="cursor: pointer;">
            <img src="https://icc-oss.oss-cn-hangzhou.aliyuncs.com/Enhe-official-website/footer-url.png" alt="">
            www.hzenhe.com
          </p>
          <p>
            <img src="https://icc-oss.oss-cn-hangzhou.aliyuncs.com/Enhe-official-website/footer-address.png" alt="">
            浙江省杭州市余杭区仓前街道浙江大学校友企业总部经济园二期D12幢13楼
          </p>
        </div>
        <div class="code-img"></div>
      </div>
      <div class="copyright">
        <span>浙江恩赫集团 版权所有</span>
        <span>浙ICP备14008288号</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      menuList: [
        {path: '/solution?id=1785210951426879490', name: '解决方案'},
        {path: '/major', name: '专业服务'},
        {path: '/news', name: '新闻活动'},
        {path: '/about', name: '关于我们'}
      ],
      currentPath: ''
    }
  },
  methods: {
    toPage (path) {
      console.log(path, this.currentPath)
      if (this.currentPath.indexOf(path) !== -1) {
        return
      }
      this.$router.push(path)
    },
    pageTo () {
      window.open('http://www.hzenhe.com', '_blank')
    }
  },
  watch: {
    $route (to, from) {
      console.log(to, from)
      this.currentPath = to.path
    }
  }
}
</script>

<style lang="less"  scoped>
  .page-footer{
    color: #fff;
    height:19.271vw;
    // margin-top: 3.125vw;
    background-color: #162A4E;
    .menu-contact{
      padding: 2.083vw 0 3.906vw;
      border-bottom: 0.052vw solid #3A4D6F;
      display: flex;
      justify-content: space-between;
      .enhe-phone{
        display: flex;
        justify-content: space-between;
        flex-direction: column;
        height: 6.563vw;
        padding-right: 3.958vw;
        border-right: 0.052vw solid #3A4D6F;
        .enhe{
          line-height: 1.875vw;
          font-size: 1.042vw;
          font-weight: 600;
          display: flex;
          column-gap: 0.833vw;
          img{
            width: 2.396vw;
            height: 1.615vw;
          }
        }
        .phone{
          background-color: #196FF1;
          display: flex;
          justify-content: center;
          align-items: center;
          height:2.396vw;
          width: 10.417vw;
          border-radius: 0.104vw;
          img{
            width: 1.094vw;
            height: 1.094vw;
          }
        }
      }
      .menu-li{
        list-style: none;
        list-style-type: none;
        width: 16.719vw;
        display: flex;
        flex-wrap: wrap;
        .menu-item{
          cursor: pointer;
          line-height: 1.823vw;
          width: 8.333vw;
          margin-bottom: 1.354vw;
        }
      }
      .address{
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        line-height: 1.042vw;
        color: rgba(255, 255, 255, 0.6);
        p{
          display: flex;
          column-gap: 0.313vw;
        }
        .title{
          color: #fff;
        }
        img{
          width:0.938vw;
          height: 0.938vw;
        }
      }
      .code-img{
        width: 6.146vw;
        height: 6.146vw;
        background: url('https://icc-oss.oss-cn-hangzhou.aliyuncs.com/Enhe-official-website/footer-code.png');
        background-size: 100% 100%;
      }
    }
    .copyright{
      margin-top: 1.667vw;
      font-size: 0.729vw;
      color: rgba(255, 255, 255, 0.3);
      display: flex;
      column-gap: 5.208vw;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/pageFooter.vue